import React from 'react';
import { TDoneVoteRatingGroup, TVotesGroup } from '../../../../store/interactive/types';
import { CheckDoneVoteRatingGroup, SendVoteRatingGroup } from '../../../../store/interactive/actions';
import { Success } from '../../../../test/screens/Sucess';
import { PollResult } from './PollResult';
import { useGroup } from './hooks/useGroup';
import { Polls } from './Polls';

interface VoteGroupProps {
  votesGroup: TVotesGroup;
  disabled: boolean;
  doneVotes: TDoneVoteRatingGroup | null;
}

export const VotesRatingGroup: React.FC<VoteGroupProps> = ({ votesGroup, disabled, doneVotes }) => {
  const { vote, end, result, sendValue } = useGroup({
    votesGroup,
    SendVote: SendVoteRatingGroup,
    CheckVoteDoneGroup: CheckDoneVoteRatingGroup,
    done: doneVotes,
  });

  if (!vote) {
    return null;
  }

  if (votesGroup.status === 3 || votesGroup.status === 1) {
    return (
      <div style={{ color: 'green', margin: '20px', textAlign: 'center' }}>
        {<span>{votesGroup.status === 1 ? 'Голосування не розпочато' : 'Голосування завершено'}</span>}
      </div>
    );
  }

  if (end) {
    return (
      <div style={{ marginTop: '40px' }}>
        <Success>
          <PollResult needBalls={result?.total || 0} balls={result?.points || 0} success={result ? result.points > 0 : false} />
        </Success>
      </div>
    );
  }

  return <Polls type="pass" vote={vote} disabled={disabled} sendValue={sendValue} />;
};
